var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroTetraeder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 48,
    viewBox: "0 0 45 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_4596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.736816 23.9992L18.2864 30.1748L22.7304 0L0.736816 23.9992Z",
    fill: "#61BFB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2864 30.1748L44.7254 23.9992L22.7304 0L18.2864 30.1748Z",
    fill: "url(#paint0_linear_62_4596)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2864 30.1749L22.7304 48.0001L0.736816 23.9993L18.2864 30.1749Z",
    fill: "#53A2A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2864 30.1749L44.7254 23.9993L22.7304 48.0001L18.2864 30.1749Z",
    fill: "url(#paint1_linear_62_4596)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_4596",
    x1: 14.042,
    y1: 25.28,
    x2: 74.023,
    y2: 50.1195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D97FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F93ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_4596",
    x1: 52.3283,
    y1: 51.2,
    x2: -56.8028,
    y2: 1.82834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#724FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#724FE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_4596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.9886,
    height: 48,
    fill: "white",
    transform: "matrix(-1 0 0 1 44.7253 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTetraeder);
export default __webpack_public_path__ + "static/media/hero-tetraeder.e55d87e975da989c84adb4ccb3113d0f.svg";
export { ForwardRef as ReactComponent };